import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "status"]

  submitOnEnter(event) {
    // Submit on Enter without Shift
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      if (this.validDraft()) this.element.requestSubmit()
    }
  }

  validateSubmission(event) {
    if (!this.validDraft()) event.preventDefault()
  }

  start() {
    this.buttonTarget.disabled = true
    this.buttonTarget.setAttribute("aria-busy", "true")
  }

  finish(event) {
    this.buttonTarget.disabled = false
    this.buttonTarget.removeAttribute("aria-busy")

    if (event.detail.success) {
      this.resetAfterSuccess()
    } else {
      this.showError("Message was not sent. Your draft is still here; check the message and try again.")
      this.inputTarget.focus()
    }
  }

  resetAfterSuccess() {
    this.inputTarget.value = ""
    this.inputTarget.focus()

    // Scroll messages container to bottom
    const container = document.getElementById("messages-container")
    if (container) {
      requestAnimationFrame(() => {
        container.scrollTop = container.scrollHeight
      })
    }
  }

  clearError() {
    this.inputTarget.removeAttribute("aria-invalid")
    this.inputTarget.removeAttribute("aria-errormessage")
    this.statusTarget.replaceChildren()
  }

  showError(message) {
    this.inputTarget.setAttribute("aria-invalid", "true")
    this.inputTarget.setAttribute("aria-errormessage", "message-compose-status")
    const error = document.createElement("p")
    error.className = "text-sm text-red-700 dark:text-red-300"
    error.setAttribute("role", "alert")
    error.textContent = message
    this.statusTarget.replaceChildren(error)
  }

  validDraft() {
    if (this.inputTarget.value.trim().length > 0) {
      this.clearError()
      return true
    }

    this.showError("Write a message before sending.")
    this.inputTarget.focus()
    return false
  }
}
